import React, { JSX } from 'react';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';
import { DropdownType } from '../../../types';
import styles from '../TagAutocompleteDropdown.module.scss';

interface CreateButtonProps {
  handleCreateNew: () => void;
  dropdownType: DropdownType;
}

const CreateButton = ({ handleCreateNew, dropdownType }: CreateButtonProps): JSX.Element => {
  return (
    <div className={styles.createButtonContainer}>
      <button className={styles.createButton} onClick={handleCreateNew}>
        <span className={styles.createButtonIcon}>
          <GenerateIcon iconName={ICONS.plus.name} />
        </span>
        <span>{`Create ${dropdownType === DropdownType.KEY ? 'Key' : 'Value'}`}</span>
      </button>
    </div>
  );
};

export default CreateButton;
